module.exports = __webpack_public_path__ + "img/tool-qa.9fc270b.jpg";